import { render, staticRenderFns } from "./DashboardClientIdPRestricition.vue?vue&type=template&id=23c4897b&"
import script from "./DashboardClientIdPRestricition.vue?vue&type=script&lang=ts&"
export * from "./DashboardClientIdPRestricition.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('23c4897b')) {
      api.createRecord('23c4897b', component.options)
    } else {
      api.reload('23c4897b', component.options)
    }
    module.hot.accept("./DashboardClientIdPRestricition.vue?vue&type=template&id=23c4897b&", function () {
      api.rerender('23c4897b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/client/clientDashboard/DashboardClientIdPRestricition.vue"
export default component.exports